import React, { useState, useContext, useEffect } from 'react';
import { ICategory } from '../../api';
import RadioConfigContext from '../../context/RadioConfigContext/RadioConfigContext';
import { CategoryChooserBox, FilterInput } from './CategoryChooser.css';
import { ChooserBody, HeaderBox, SingleCountry, CountryName, ChooseCoutryBox } from '../ChooseCountry/ChooseCountry.css';

const CategoryChooser = (props: { categories: ICategory[], setShowFavs: (showFavs: boolean) => void }) => {
  const { radioConfig, setRadioConfig } =  useContext(RadioConfigContext);
  const [filterValue, setFilterValue] = useState('');
  const [filteredCategories, setFilteredCategories] = useState(props.categories);
  const [openCategoryChoser, setOpenCategoryChooser] = useState(false);

  useEffect(() => {
    setFilteredCategories(props.categories);
  }, [props.categories]);

  const handleChangeCategory = (id: number, name: string) => {
    props.setShowFavs(false);
    setRadioConfig({...radioConfig, currentCategory: id, currentCategoryName: name});
    setOpenCategoryChooser(false);
  };

  const handleFilterCategories = (e: any) => {
    const val = e.target.value as string;
    console.log(val);
    setFilterValue(val);
    if (val.length > 0) {
      setFilteredCategories([...props.categories.filter( x => x.name.toLowerCase().indexOf(val.toLowerCase()) > -1 )])
    } else {
      setFilteredCategories(props.categories);
    }
  }

  return (
    <ChooseCoutryBox>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1}} onClick={() => setOpenCategoryChooser(true)}>
        <i className="fa fa-bars" />
      </div>
      <CategoryChooserBox open={openCategoryChoser}>
        <HeaderBox onClick={() => setOpenCategoryChooser(false)}>CHOOSE GENRE <i className="fa fa-window-close" /></HeaderBox>
        <FilterInput placeholder="Search genre" type="text" value={filterValue} onChange={handleFilterCategories} />
        <ChooserBody>
          {filteredCategories.map((cat) => <SingleCountry style={{padding: 5}} active={radioConfig.currentCategory === cat.id} onClick={() => handleChangeCategory(cat.id, cat.name)}><CountryName active={radioConfig.currentCategory === cat.id}>{cat.name}</CountryName></SingleCountry>)}
        </ChooserBody>
      </CategoryChooserBox>
    </ChooseCoutryBox>
  );
};

export default CategoryChooser;